import axios from "axios";
var AxiosService = /** @class */ (function () {
    function AxiosService(baseURL) {
        this.axiosInstance = axios.create({
            baseURL: baseURL,
            headers: {
                "Content-Type": "application/json",
            },
        });
        this.setupInterceptors();
    }
    AxiosService.prototype.setupInterceptors = function () {
        this.axiosInstance.interceptors.request.use(function (config) {
            var session = localStorage.getItem("session");
            if (session) {
                config.headers["session"] = session;
            }
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
    };
    AxiosService.getInstance = function (baseURL) {
        if (!AxiosService.instance) {
            AxiosService.instance = new AxiosService(baseURL);
        }
        return AxiosService.instance;
    };
    AxiosService.prototype.getAxiosInstance = function () {
        return this.axiosInstance;
    };
    return AxiosService;
}());
export { AxiosService };
// You'll need to provide the baseURL when getting the instance
// export const axiosInstance = AxiosService.getInstance('YOUR_BASE_URL_HERE').getAxiosInstance();
